/*
 * Copyright (c) 2021. World Wide Generation Ltd
 */

import React from 'react';
import WWGLogo from '../../images/wwg-logo-landscape.svg';
import { Link, useParams } from 'react-router-dom';
import { Params } from './index';
import { Card } from '../../routes/home/partials/cards';

interface SolutionsProps {
  heading: string;
  cards: Card[]
}

const Solutions = (props: SolutionsProps) => {
  const { cards, heading } = props;
  const params = useParams<Params>()
  const productCards = cards.filter(product => product.isProduct && product.slug !== params.slug);
  return <div className='solutions-container mt-5'>
    <div className='solution-content px-4'>
      <h2 className='mb-4 strong'>{heading}</h2>
      <div
        className='d-flex flex-wrap flex-gap flex-column flex-md-row' >
        {productCards.map((card, i) => <Link
          to={`/products/${card.slug}`}
          key={`header-card-${i}`}
        >
          <div>
            <div className='h-100 d-flex flex-column solution-logos' >
              <div className='product-card-logo solution-card-logo text-right d-flex justify-content-center align-items-center position-relative'>
                <img src={card.logo} alt={'Logo'} width='140' />
                <div className='position-absolute pl-2 pb-1' style={{ bottom: 0, left: 0 }}>
                  <img src={WWGLogo} width={60} alt='WWG Logo' />
                </div>
              </div>
            </div>
          </div>
        </Link>
        )}
      </div>
    </div>
  </div>
}

export default Solutions;

